import React, { useEffect, useRef, useState } from 'react'
import { Input } from 'antd'
import { SearchOutlined } from '@ant-design/icons'

interface SearchInputProps {
  onSearch: (value: string) => void
  placeholder?: string
  delay?: number
  width?: number | string
  initialValue?: string
}

export const SearchInput: React.FC<SearchInputProps> = ({
  onSearch,
  placeholder = 'Search by name...',
  delay = 300,
  width = 260,
  initialValue = '',
}) => {
  const [value, setValue] = useState(initialValue)
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  const onSearchRef = useRef(onSearch)

  useEffect(() => {
    onSearchRef.current = onSearch
  }, [onSearch])

  useEffect(() => {
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current)
    }
  }, [])

  const handleChange = (next: string) => {
    setValue(next)
    if (debounceRef.current) clearTimeout(debounceRef.current)
    debounceRef.current = setTimeout(() => {
      onSearchRef.current(next)
    }, delay)
  }

  return (
    <Input
      placeholder={placeholder}
      prefix={<SearchOutlined />}
      allowClear
      value={value}
      onChange={(e) => handleChange(e.target.value)}
      style={{ width }}
    />
  )
}
